export const MENU_LAYOUT_ID = 'menu-layout';
export const ORDER_SETTINGS_ID = 'order-setting';
export const CART_LAYOUT_ID = 'cart-layout';
